export const bgColors = [
    '#FAFF00',
    '#00C2FF',
    '#DF27FD',
    '#FF005C'
];